module.exports = __webpack_public_path__ + "menu.png";